import { createAction } from 'redux-actions';
import { QueryProps } from 'modules/advisors/endpoints';
import Types from './types';

export const getAllAdvisorsRequest = createAction(
  Types.GET_ALL_ADVISORS_REQUEST
);
export const getAllAdvisorsFulfilled = createAction(
  Types.GET_ALL_ADVISORS_FULFILLED
);
export const getAllAdvisorsRejected = createAction(
  Types.GET_ALL_ADVISORS_REJECTED
);

export const getAdvisorRequest = createAction(Types.GET_ADVISOR_REQUEST);
export const getAdvisorFulfilled = createAction(Types.GET_ADVISOR_FULFILLED);
export const getAdvisorRejected = createAction(Types.GET_ADVISOR_REJECTED);

export const applyAdvisorRequest = createAction(Types.APPLY_ADVISOR_REQUEST);
export const applyAdvisorFulfilled = createAction(
  Types.APPLY_ADVISOR_FULFILLED
);
export const applyAdvisorRejected = createAction(Types.APPLY_ADVISOR_REJECTED);

export const ignoreAdvisorRequest = createAction(Types.IGNORE_ADVISOR_REQUEST);
export const ignoreAdvisorFulfilled = createAction(
  Types.IGNORE_ADVISOR_FULFILLED
);
export const ignoreAdvisorRejected = createAction(
  Types.IGNORE_ADVISOR_REJECTED
);

export const revertAdvisorRequest = createAction(Types.REVERT_ADVISOR_REQUEST);
export const revertAdvisorFulfilled = createAction(
  Types.REVERT_ADVISOR_FULFILLED
);
export const revertAdvisorRejected = createAction(
  Types.REVERT_ADVISOR_REJECTED
);

export const getDashboardRequest = createAction(
  Types.GET_DASHBOARD_REQUEST,
  (query: QueryProps) => ({ query })
);
export const getDashboardFulfilled = createAction(
  Types.GET_DASHBOARD_FULFILLED
);
export const getDashboardRejected = createAction(Types.GET_DASHBOARD_REJECTED);
